import { sanitize } from '@ibe/services';
import { ApiHotel, ApiHotelRoom, ApiRoomRate } from '@ibe/api';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import React, { JSX } from 'react';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';
import getIconForItemTye from '../Base/getItemForItemType';
import SummaryItem from '../../Components/Cart/SummaryItem/SummaryItem';
import SummaryTabs from '../Base/SummaryTabs';
import Dates from '../Dates';
import fallback from '../../../_Translations/generated/summary.en.t.json';
import Keys from '../../../_Translations/generated/summary.en.t.json.keys';
import useTranslation from '../../../ISO/Hooks//useTranslation';

const Summary = (props: BookedItemComponentProps): JSX.Element => {
  const {
    item,
    isOpen,
    showInfo,
    showTraveler,
    travelerId,
    booking,
    onDelete,
    showAdditionalInfo,
    withIconColumn,
    hideSinglePrices,
    showNumberOfPerson,
    customPriceModifier,
    customLabelsMapper,
    order,
    showPricePlusMinus
  } = props;

  const { t } = useTranslation('summary', fallback, Keys);
  const icon = getIconForItemTye(item.itemType);
  const roomRate = booking.items.find(it => item.idParent === it.id) as ApiRoomRate;
  const room = booking.items.find(it => roomRate.idParent === it.id) as ApiHotelRoom;
  const hotel = booking.items.find(it => room.idParent === it.id) as ApiHotel;

  const numberOfPersonLabel = showNumberOfPerson
    ? t(Keys.numberOfPerson, {
        count: Object.keys(item.priceByPersonId).length,
        numberOfPerson: Object.keys(item.priceByPersonId).length
      })
    : '';

  const InfoTabContent = (): JSX.Element => {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: sanitize(hotel.name) }} />
        <div dangerouslySetInnerHTML={{ __html: sanitize(room.description) }} />
        <div dangerouslySetInnerHTML={{ __html: sanitize(roomRate.mealTypeDescription) }} />
        {numberOfPersonLabel ? (
          <div dangerouslySetInnerHTML={{ __html: sanitize(numberOfPersonLabel) }} />
        ) : null}
      </>
    );
  };

  const customPrice = customPriceModifier && customPriceModifier(item, travelerId);
  const customLabel = customLabelsMapper && customLabelsMapper(item);
  return (
    <SummaryItem
      title={hotel.name || ''}
      price={customPrice || item.price}
      subtitle={item.itemType}
      description={customLabel || room.name}
      additionalInfo={showAdditionalInfo ? roomRate.mealTypeDescription : undefined}
      icon={<Icon icon={icon} />}
      dates={<Dates item={item} />}
      isOpen={isOpen}
      onDelete={onDelete}
      booking={booking}
      item={item}
      withIconColumn={withIconColumn}
      hideSinglePrices={hideSinglePrices}
      order={order?.Hotel}
      numberOfPerson={numberOfPersonLabel}
      showPricePlusMinus={showPricePlusMinus}
    >
      {(showInfo || showTraveler) && (
        <SummaryTabs
          booking={booking}
          item={item}
          info={<InfoTabContent />}
          showInfo={showInfo}
          showTraveler={showTraveler}
        />
      )}
    </SummaryItem>
  );
};

export default Summary;
